import { ReactNode } from "react";
import styles from "./Texts.module.css";

type TextsProps = {
  children: ReactNode;
};

function Texts({ children }: TextsProps) {
  return <div className={styles["root"]}>{children}</div>;
}

export default Texts;
